import {makeLinksOpenInNewTab} from "../utils/rich-editor-helper";

function initEmployerDetails() {
  const employerDescriptionContainer = $('#employer-details-description-container');

  if (employerDescriptionContainer.length) {
    makeLinksOpenInNewTab('#employer-details-description-container .html-content');
  }
}

$(initEmployerDetails);

